function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".hero_svg__st27{fill:#192f28}.hero_svg__st48{fill:#8ecda1}.hero_svg__st61{fill:#fff}.hero_svg__st62{fill:#3fb782}.hero_svg__st63{fill:#7dc9a8}.hero_svg__st69{fill:#46484a}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Layer_2_1_"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M202.9 412L99.3 471.7c-2.1-1.1-4.7-1.1-6.8 0-1.2.5-1.9 1.9-1.4 3.1.2.6.8 1.2 1.4 1.4 2.1 1.1 4.7 1.1 6.8 0 .9-.4 1.5-1.3 1.6-2.2 0-.6-.3-1.1-.7-1.6l103.3-59.5-.6-.9zM98.8 475.3c-1.8.9-4 .9-5.8 0-.8-.2-1.2-1-1-1.8.1-.5.5-.9 1-1 1.8-.9 4-.9 5.8 0 .8.2 1.2 1 1 1.8-.2.5-.5.9-1 1zm82.8-76.3l-.5-.9-103.6 59.7c-2.1-1.1-4.7-1.1-6.8 0-1.2.5-1.9 1.9-1.4 3.1.2.6.7 1.1 1.4 1.4 2.1 1.1 4.7 1.1 6.8 0 .9-.4 1.5-1.3 1.5-2.3 0-.6-.3-1.1-.7-1.5L181.6 399zM77 461.4c-1.8.9-4 .9-5.8 0-.8-.2-1.2-1-1-1.8.1-.5.5-.9 1-1 1.8-.9 4-.9 5.8 0 .8.2 1.2 1 1 1.8-.1.5-.5.9-1 1zm439.4-118.9L314.9 226l-.5.9 201.5 116.5c2.1 1.2 2.9 4 1.6 6.2-.4.7-1 1.2-1.6 1.6L397.7 420c-2.1-1.1-4.7-1.1-6.8 0-1.2.5-1.9 1.9-1.4 3.1.2.6.7 1.1 1.4 1.4 2.1 1.1 4.7 1.1 6.8 0 .9-.4 1.5-1.3 1.6-2.2 0-.6-.3-1.1-.7-1.5l55.9-32.6 26.8 15.3c2.2 1.2 2.9 4 1.6 6.1-.4.7-1 1.2-1.6 1.6l-75.4 44.1c-3 1.7-6.6 1.7-9.5 0l-63.8-36.8 92.1-53.4c2.6-1.5 3.5-4.9 2-7.5-.5-.8-1.2-1.5-2-2l-130.7-76-.5.9 130.7 76c2.1 1.2 2.9 4 1.6 6.2-.4.7-1 1.2-1.6 1.6l-129.7 75.2c-2.1-1-4.5-.9-6.5.1-1.2.5-1.9 1.9-1.4 3.1.2.6.7 1.1 1.4 1.4 2.1 1.1 4.7 1.1 6.8 0 .9-.4 1.5-1.3 1.5-2.2 0-.7-.3-1.3-.9-1.8l36.1-21 64.2 37.1c3.3 1.9 7.3 1.9 10.6 0l75.4-44.3c2.6-1.5 3.5-4.9 2-7.5-.5-.8-1.2-1.5-2-2l-26.2-15 61-35.5c2.6-1.5 3.5-4.9 2-7.5-.5-.8-1.2-1.5-2.1-1.9zM294.2 443.3c-1.8.9-4 .9-5.8 0-.8-.2-1.2-1-1-1.8.1-.5.5-.9 1-1 1.8-.9 4-.9 5.8 0 .8.2 1.2 1 1 1.8-.1.5-.5.8-1 1zm103-19.8c-1.8.9-4 .9-5.8 0-.6-.2-1-.8-1-1.4.1-.6.5-1.1 1-1.4 1.8-.9 4-.9 5.8 0 .6.2 1 .8 1.1 1.4-.1.7-.5 1.2-1.1 1.4z",
  fill: "#24615d"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 112.81,
  y1: 235.425,
  x2: 70.31,
  y2: 235.425,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M107.2 270.7c-.1 10.8-35.9 10.5-35.8-.3l.1-8 35.8.3-.1 8z",
  fill: "url(#hero_svg__SVGID_1_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 71.703,
  y1: 222.117,
  x2: 94.083,
  y2: 249.077,
  gradientTransform: "matrix(1 0 0 -1 -.017 505.996)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M71.4 262.5c0-4.9 8.1-8.7 18-8.7s17.9 4.1 17.9 8.9c0 4.9-8.1 8.7-18 8.7-10 0-17.9-4-17.9-8.9z",
  fill: "url(#hero_svg__SVGID_2_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 70.89,
  y1: 238.764,
  x2: 107.75,
  y2: 238.764,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M71.4 262.5c0 4.9 8 8.9 17.9 8.9s18-3.8 18-8.6",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_3_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(.00768 -1 1 .00768 -161.854 337.246)",
  cx: 89,
  cy: 250.2,
  rx: 7.1,
  ry: 14.5
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 337.339,
  y1: 4304.433,
  x2: 353.089,
  y2: 4280.353,
  gradientTransform: "scale(-1 1) rotate(59.563 3653.981 1894.888)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d0455e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#c6425e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#aa395c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#7d2c5a",
  stopOpacity: 0.99
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4d1d58",
  stopOpacity: 0.99
})), /*#__PURE__*/React.createElement("path", {
  d: "M74.7 256.7c0-3.9 6.5-7 14.5-7 8 .1 14.4 3.3 14.4 7.2 0 3.9-6.5 7-14.5 7-8-.1-14.5-3.3-14.4-7.2z",
  fill: "url(#hero_svg__SVGID_4_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 36.76,
  y1: 189.663,
  x2: -9.6,
  y2: 189.663,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.3 316.5C36.2 327.3.4 327 .5 316.2l.1-8 35.8.3-.1 8z",
  fill: "url(#hero_svg__SVGID_5_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: -6.131,
  y1: 170.952,
  x2: 27.189,
  y2: 207.072,
  gradientTransform: "matrix(1 0 0 -1 -.01 505.988)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M.5 308.3c0-4.9 8.1-8.7 18-8.7 9.9.1 17.9 4.1 17.9 8.9 0 4.9-8.1 8.7-18 8.7S.5 313.1.5 308.3z",
  fill: "url(#hero_svg__SVGID_6_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 0,
  y1: 193.004,
  x2: 36.85,
  y2: 193.004,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M.5 308.3c0 4.9 8 8.9 17.9 8.9s18-3.8 18-8.6",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_7_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_8_",
  gradientUnits: "userSpaceOnUse",
  x1: 13.515,
  y1: 222.938,
  x2: 19.405,
  y2: 206.428,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.6 296.1c0-3.9-6.4-8.3-14.4-8.3S3.7 292 3.6 295.9s6.4 7.2 14.4 7.2 14.6-3.1 14.6-7z",
  fill: "url(#hero_svg__SVGID_8_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_9_",
  gradientUnits: "userSpaceOnUse",
  x1: 15.85,
  y1: 258.545,
  x2: 46.26,
  y2: 239.215,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M31.5 308.4H5.3c-.1-22.3 7.1-44.1 20.5-62 12.7-16.7 29.1-26.6 44-26.6 9.7-.1 18.9 4.5 24.5 12.5 5.4 7.4 8.1 17.6 8.1 30.3H76.2c0-9.6-2.2-13.7-3.1-15-.7-1.1-2-1.8-3.3-1.6-5.2 0-14.6 5.1-23.1 16.3-10 13.3-15.3 29.5-15.2 46.1z",
  fill: "url(#hero_svg__SVGID_9_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_10_",
  gradientUnits: "userSpaceOnUse",
  x1: 39.3,
  y1: 201.19,
  x2: 3.87,
  y2: 201.19,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.7 307.2l-.1-11.4c0 3.9 6.4 7.2 14.5 7.2s14.5-3.1 14.5-7l.1 11.4c0 8.7-29 8.5-29-.2z",
  fill: "url(#hero_svg__SVGID_10_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_11_",
  gradientUnits: "userSpaceOnUse",
  x1: 74.51,
  y1: 246.955,
  x2: 103.65,
  y2: 246.955,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M74.6 261.4l-.1-11.4c0 3.9 6.4 7.2 14.5 7.2s14.5-3.1 14.6-7l.1 11.4c-.1 8.8-29.1 8.6-29.1-.2z",
  fill: "url(#hero_svg__SVGID_11_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_12_",
  gradientUnits: "userSpaceOnUse",
  x1: 74.01,
  y1: 252.14,
  x2: 104.04,
  y2: 252.14,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M74.5 250c0 3.9 6.4 7.2 14.5 7.2s14.5-3.1 14.6-7",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_12_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_13_",
  gradientUnits: "userSpaceOnUse",
  x1: 3.12,
  y1: 206.37,
  x2: 33.14,
  y2: 206.37,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.6 295.8c0 3.9 6.4 7.2 14.5 7.2s14.5-3.1 14.5-7",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_13_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_14_",
  gradientUnits: "userSpaceOnUse",
  x1: 147.89,
  y1: 214.28,
  x2: 105.39,
  y2: 214.28,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M142.3 291.9c-.1 10.8-35.9 10.5-35.8-.3l.1-8 35.8.3-.1 8z",
  fill: "url(#hero_svg__SVGID_14_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_15_",
  gradientUnits: "userSpaceOnUse",
  x1: 106.787,
  y1: 200.994,
  x2: 129.167,
  y2: 227.954,
  gradientTransform: "matrix(1 0 0 -1 -.018 505.99)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M106.5 283.6c0-4.9 8.1-8.7 18-8.7 9.9.1 17.9 4.1 17.9 8.9 0 4.9-8.1 8.7-18 8.7-10 0-18-4-17.9-8.9z",
  fill: "url(#hero_svg__SVGID_15_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_16_",
  gradientUnits: "userSpaceOnUse",
  x1: 105.97,
  y1: 217.644,
  x2: 142.83,
  y2: 217.644,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M106.5 283.6c0 4.9 8 8.9 17.9 8.9s18-3.8 18-8.6",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_16_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(.00768 -1 1 .00768 -148.177 393.295)",
  cx: 124.1,
  cy: 271.3,
  rx: 7.1,
  ry: 14.5
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_17_",
  gradientUnits: "userSpaceOnUse",
  x1: 335.766,
  y1: 4339.336,
  x2: 351.529,
  y2: 4315.252,
  gradientTransform: "matrix(-.5067 .8661 .8661 .5067 -3441.708 -2212.592)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d0455e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#c6425e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#aa395c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#7d2c5a",
  stopOpacity: 0.99
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4d1d58",
  stopOpacity: 0.99
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.8 277.8c0-3.9 6.5-7 14.5-7s14.4 3.3 14.4 7.2-6.5 7-14.5 7-14.5-3.2-14.4-7.2z",
  fill: "url(#hero_svg__SVGID_17_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_18_",
  gradientUnits: "userSpaceOnUse",
  x1: 71.84,
  y1: 168.545,
  x2: 25.47,
  y2: 168.545,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M71.4 337.6c-.1 10.8-35.9 10.5-35.8-.3l.1-8 35.8.3-.1 8z",
  fill: "url(#hero_svg__SVGID_18_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_19_",
  gradientUnits: "userSpaceOnUse",
  x1: 28.948,
  y1: 149.833,
  x2: 62.268,
  y2: 185.952,
  gradientTransform: "matrix(1 0 0 -1 -.01 505.982)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M35.6 329.4c0-4.9 8.1-8.7 18-8.7 9.9.1 17.9 4.1 17.9 8.9 0 4.9-8.1 8.7-18 8.7-10-.1-18-4.1-17.9-8.9z",
  fill: "url(#hero_svg__SVGID_19_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_20_",
  gradientUnits: "userSpaceOnUse",
  x1: 35.08,
  y1: 171.884,
  x2: 71.93,
  y2: 171.884,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M35.6 329.4c0 4.9 8 8.9 17.8 8.9s18-3.8 18-8.6",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_20_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_21_",
  gradientUnits: "userSpaceOnUse",
  x1: 48.577,
  y1: 201.815,
  x2: 54.477,
  y2: 185.305,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.7 317.2c0-3.9-6.4-8.3-14.4-8.3S38.7 313 38.7 317s6.4 7.2 14.4 7.2 14.6-3.1 14.6-7z",
  fill: "url(#hero_svg__SVGID_21_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_22_",
  gradientUnits: "userSpaceOnUse",
  x1: 34.266,
  y1: 238.5,
  x2: 79.516,
  y2: 219.17,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M66.6 329.5H40.4c-.1-22.3 7.1-44.1 20.5-62 12.7-16.6 29.1-26.5 44-26.5 9.7-.1 18.9 4.5 24.5 12.5 5.4 7.4 8.1 17.6 8.1 30.3h-26.2c0-9.6-2.2-13.7-3.1-15-.7-1.1-2-1.8-3.3-1.6-5.2 0-14.6 5.1-23.1 16.3-10 13.2-15.3 29.4-15.2 46z",
  fill: "url(#hero_svg__SVGID_22_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_23_",
  gradientUnits: "userSpaceOnUse",
  x1: 74.38,
  y1: 180.079,
  x2: 38.95,
  y2: 180.079,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M38.8 328.3l-.1-11.4c0 3.9 6.5 7.2 14.5 7.2s14.5-3.1 14.6-7l.1 11.4c-.1 8.7-29.1 8.5-29.1-.2z",
  fill: "url(#hero_svg__SVGID_23_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_24_",
  gradientUnits: "userSpaceOnUse",
  x1: 109.59,
  y1: 225.829,
  x2: 138.73,
  y2: 225.829,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.7 282.6l-.1-11.4c0 3.9 6.4 7.2 14.5 7.2s14.5-3.1 14.6-7l.1 11.4c-.1 8.7-29.2 8.5-29.1-.2z",
  fill: "url(#hero_svg__SVGID_24_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_25_",
  gradientUnits: "userSpaceOnUse",
  x1: 109.09,
  y1: 231.01,
  x2: 139.11,
  y2: 231.01,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.6 271.1c0 3.9 6.4 7.2 14.5 7.2s14.5-3.1 14.6-7",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_25_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_26_",
  gradientUnits: "userSpaceOnUse",
  x1: 38.19,
  y1: 185.25,
  x2: 68.22,
  y2: 185.25,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M38.7 316.9c0 3.9 6.5 7.2 14.5 7.2s14.5-3.1 14.6-7",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_26_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M97.5 373.3c-2.6-6.2-15.5 7.7-7.2 12.8-.3 3.1.4 9.7 2.4 12.1 1.4 1.7 4.1-1.3 4.9-1.7l-.1-23.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_27_",
  gradientUnits: "userSpaceOnUse",
  x1: 14868.94,
  y1: 120.769,
  x2: 14845.71,
  y2: 120.769,
  gradientTransform: "rotate(180 7474.68 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M97.5 373.3c-2.6-6.2-15.5 7.7-7.2 12.8-.3 3.1.4 9.7 2.4 12.1 1.4 1.7 4.1-1.3 4.9-1.7l-.1-23.2z",
  fill: "url(#hero_svg__SVGID_27_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_28_",
  gradientUnits: "userSpaceOnUse",
  x1: 227.39,
  y1: 395.204,
  x2: 253.96,
  y2: 436.753,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M202.7 100.6v-46c0-10.6 3.3-18.3 9.3-21.8s14.4-2.5 23.5 2.8c20.8 12 37.8 41.4 37.8 65.5v40.2l5.8 3.4 4.2 2.4v-46c0-27.3-19.2-60.5-42.8-74.2-12.4-7.1-24.3-8.1-33.5-2.8s-14.3 16.1-14.3 30.4v40.2l5.8 3.3 4.2 2.6z",
  fill: "url(#hero_svg__SVGID_28_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_29_",
  gradientUnits: "userSpaceOnUse",
  x1: 121.137,
  y1: 358.61,
  x2: 125.717,
  y2: 442.46,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_29_)",
  d: "M82.3 315.5l74-42.7V45.4l-37 54.6-37-11.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_30_",
  gradientUnits: "userSpaceOnUse",
  x1: 238.01,
  y1: 305.81,
  x2: 315.76,
  y2: 423.96,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_30_)",
  d: "M313.9 363.8l-157.6-91V45.4l157.6 91z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_31_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.301,
  y1: 358.12,
  x2: 213.941,
  y2: 493.06,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_31_)",
  d: "M82.3 88.2l157.6 90.9 42.6 25.8 31.4-68.5V0H82.3z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_32_",
  gradientUnits: "userSpaceOnUse",
  x1: 166.411,
  y1: 373.454,
  x2: 201.031,
  y2: 459.324,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M128.7 143.1V97c0-10.6 3.3-18.3 9.3-21.8s14.4-2.5 23.5 2.8c20.9 12 37.8 41.4 37.8 65.5v40.2l5.8 3.4 4.2 2.4v-46c0-27.3-19.2-60.5-42.8-74.2-12.4-7.1-24.3-8.1-33.5-2.8S118.7 82.8 118.7 97v40.2l5.8 3.3 4.2 2.6z",
  fill: "url(#hero_svg__SVGID_32_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_33_",
  gradientUnits: "userSpaceOnUse",
  x1: 93.539,
  y1: 102.031,
  x2: 204.069,
  y2: 358.14,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_33_)",
  d: "M239.9 406.6l-157.6-91V88.2l157.6 90.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_34_",
  gradientUnits: "userSpaceOnUse",
  x1: 256.59,
  y1: 108.33,
  x2: 303.09,
  y2: 397.22,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_34_)",
  d: "M239.9 406.6l74-42.7V136.4l-37 54.7-37-12z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_35_",
  gradientUnits: "userSpaceOnUse",
  x1: -861.457,
  y1: 248.446,
  x2: -822.759,
  y2: 177.691,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_35_)",
  d: "M349.9 273.6l39.8 23 39.8-23-39.8-23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_36_",
  gradientUnits: "userSpaceOnUse",
  x1: -797.899,
  y1: 345.154,
  x2: -885.029,
  y2: 161.684,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_36_)",
  d: "M389.7 362.5l39.8-22.9v-66l-39.8 23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_37_",
  gradientUnits: "userSpaceOnUse",
  x1: -798.223,
  y1: 319.138,
  x2: -819.393,
  y2: 238.728,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_37_)",
  d: "M389.7 362.5l-39.8-22.9v-66l39.8 23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_38_",
  gradientUnits: "userSpaceOnUse",
  x1: -809.204,
  y1: 301.669,
  x2: -774.744,
  y2: 189.809,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_38_)",
  d: "M303 215.5l39.8 23 39.8-23-39.8-23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_39_",
  gradientUnits: "userSpaceOnUse",
  x1: -765.649,
  y1: 329.84,
  x2: -852.779,
  y2: 146.37,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_39_)",
  d: "M342.8 389.5l39.8-22.9V215.5l-39.8 23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_40_",
  gradientUnits: "userSpaceOnUse",
  x1: -758.184,
  y1: 308.608,
  x2: -779.354,
  y2: 228.189,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_40_)",
  d: "M342.8 389.5L303 366.6V215.5l39.8 23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_41_",
  gradientUnits: "userSpaceOnUse",
  x1: -774.463,
  y1: 249.699,
  x2: -718.833,
  y2: 147.519,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_41_)",
  d: "M256.1 285l39.8 22.9 39.8-22.9-39.8-23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_42_",
  gradientUnits: "userSpaceOnUse",
  x1: -708.694,
  y1: 302.792,
  x2: -795.824,
  y2: 119.322,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_42_)",
  d: "M295.9 416.5l39.8-23V285l-39.8 22.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_43_",
  gradientUnits: "userSpaceOnUse",
  x1: -692.232,
  y1: 251.751,
  x2: -747.862,
  y2: 136.871,
  gradientTransform: "rotate(180 -231.49 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_43_)",
  d: "M295.9 416.5l-39.8-23V285l39.8 22.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_44_",
  gradientUnits: "userSpaceOnUse",
  x1: -991.42,
  y1: 700.67,
  x2: -991.42,
  y2: 599.88,
  gradientTransform: "matrix(-.87 -.5 0 -1.15 -774.2 464.96)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#36b88c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_44_)",
  d: "M153.9 257.9l-52.5-30.3-26.2-60.5-13.1 7.6L49 212.1l-12.5 8.2-13.8-8v30.2l131.2 75.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_45_",
  gradientUnits: "userSpaceOnUse",
  x1: -991.42,
  y1: 705.97,
  x2: -991.42,
  y2: 625.15,
  gradientTransform: "matrix(-.87 -.5 0 -1.15 -774.2 464.96)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#36b88c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_45_)",
  d: "M153.9 203.1l-26.2-27.3-13.1 4.6-39.4 35.7L49 173.3l-13.3-41-13-15v125.2l131.2 75.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.1 167L22.9 91.3c-.1-.1-.3 0-.3.1v151.1c0 .1 0 .2.1.2l131.2 75.7h.2c.1 0 .1-.1.1-.2v-151c0-.1-.1-.2-.1-.2zm-52.9 45l-12.6-7.3v-14.5l12.6 7.3V212zm.5-14.2l12.6 7.3v14.5l-12.6-7.3v-14.5zm-13.1-8.2v-14.5l12.6 7.3v14.5l-12.6-7.3zm-.5-.3L75.5 182v-14.5l12.6 7.3v14.5zm0 .6v14.5l-12.6-7.3v-14.5l12.6 7.3zm-13.1 7l-12.6-7.3v-14.5l12.6 7.3v14.5zm-13.1-7.6L49.2 182v-14.5l12.6 7.3.1 14.5zm0 .6v14.5l-12.6-7.3v-14.5l12.6 7.3zm.5.3l12.6 7.3V212l-12.6-7.3v-14.5zm13.1 7.6l12.6 7.2v14.5l-12.6-7.3v-14.4zm12.6 22.3v14.5l-12.6-7.3v-14.5l12.6 7.3zm.5.3l12.6 7.3v14.5l-12.6-7.3v-14.5zm0-.6v-14.5l12.6 7.3v14.5l-12.6-7.3zm13.1-6.9l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.2 7.6l12.6 7.3v14.5l-12.7-7.3.1-14.5zm0-.6v-14.5l12.6 7.3v14.5l-12.6-7.3zm0-15.1v-14.5l12.6 7.3v14.5l-12.6-7.3zm-.5-.3l-12.6-7.3v-14.5l12.6 7.3v14.5zm-12.7-22.4v-14.5l12.6 7.3v14.5l-12.6-7.3zm-.5-.2l-12.6-7.3v-14.5l12.6 7.3v14.5zm-13.1-7.6L75.5 167v-14.5l12.6 7.3v14.5zM75 166.7l-12.6-7.3v-14.5l12.6 7.3v14.5zm0 .6v14.5l-12.6-7.3V160l12.6 7.3zm-13.1 6.9l-12.6-7.3v-14.5l12.6 7.3v14.5zm-13.1-7.6l-12.6-7.3v-14.5l12.6 7.3v14.5zm0 .6v14.5l-12.6-7.3v-14.5l12.6 7.3zm0 15.1v14.5l-12.6-7.3V175l12.6 7.3zm0 15.1v14.5l-12.6-7.3v-14.5l12.6 7.3zm.5.3l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zM75 227.6v14.5l-12.6-7.3v-14.5l12.6 7.3zm.5.3l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.1 7.6l12.6 7.3v14.5L88.6 250v-14.5zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm0-.6V228l12.6 7.3v14.5l-12.6-7.3zm13.2-6.9l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.1 7.5l12.6 7.3v14.5l-12.6-7.3v-14.5zm0-.5V228l12.6 7.3v14.5l-12.6-7.2zm0-15.1V213l12.6 7.3v14.5l-12.6-7.3zm0-15.1v-14.5l12.6 7.3v14.5l-12.6-7.3zm0-15.1v-14.5l12.6 7.3v14.5l-12.6-7.3zm-.5-.3l-12.6-7.3v-14.5l12.6 7.3V197zm-12.6-22.4v-14.5l12.6 7.3v14.5l-12.6-7.3zm-.5-.3l-12.6-7.3v-14.5l12.6 7.3v14.5zm-13.2-7.5l-12.6-7.3V145l12.6 7.3v14.5zm-13.1-7.6l-12.7-7.3v-14.5l12.6 7.3.1 14.5zM75 151.6l-12.6-7.3v-14.5l12.6 7.3v14.5zM61.8 144l-12.6-7.3v-14.5l12.6 7.3V144zm0 .6v14.5l-12.6-7.3v-14.5l12.6 7.3zm-13.1 6.9l-12.6-7.3v-14.5l12.6 7.2v14.6zM35.6 144L23 136.7v-14.5l12.6 7.3V144zm0 .6v14.5L23 151.8v-14.5l12.6 7.3zm0 15.1v14.5L23 166.9v-14.5l12.6 7.3zm0 15.1v14.5L23 182v-14.6l12.6 7.4zm0 15.1v14.5L23 197.1v-14.5l12.6 7.3zM23 197.6l12.6 7.3v14.5L23 212.1v-14.5zm13.1 7.6l12.6 7.3V227l-12.6-7.3v-14.5zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm12.6 22.4v14.5l-12.6-7.3v-14.5l12.6 7.3zm.5.2l12.7 7.3v14.5L62.3 250v-14.6zm13.2 7.6l12.6 7.3v14.5l-12.6-7.3V243zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.1 7.5l12.6 7.3V280l-12.6-7.3v-14.6zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm0-.6v-14.5l12.6 7.3v14.5l-12.6-7.3zm13.1-6.9l12.6 7.3V280l-12.6-7.3v-14.5zm13.2 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm0-.6v-14.5l12.6 7.3v14.5l-12.6-7.3zm0-15.1v-14.5l12.6 7.3v14.5l-12.6-7.3zm0-15.1v-14.5l12.6 7.3v14.5l-12.6-7.3zm0-15.1v-14.5l12.6 7.3v14.5l-12.6-7.3zm0-15v-14.5l12.6 7.3v14.5l-12.6-7.3zm12.6-7.8l-12.6-7.3v-14.5l12.6 7.3v14.5zm-13.1-7.6l-12.6-7.3v-14.5l12.6 7.3v14.5zm-12.7-22.4v-14.6l12.6 7.3v14.6l-12.6-7.3zm-.5-.3l-12.6-7.3V145l12.6 7.3v14.5zm-13.1-7.6l-12.6-7.2v-14.6l12.6 7.3v14.5zm-13.1-7.5l-12.6-7.3v-14.6l12.6 7.3v14.6zm-13.1-7.6l-12.6-7.3v-14.6l12.6 7.3v14.6zM75 136.5l-12.6-7.3v-14.6L75 122v14.5zM61.8 129l-12.6-7.3v-14.6l12.6 7.3V129zm-13.1-7.6l-12.6-7.3V99.5l12.6 7.3v14.6zm0 .6v14.5l-12.6-7.3v-14.6l12.6 7.4zm-13.1 6.9L23 121.6v-14.5l12.6 7.3v14.5zM23 212.7l12.6 7.3v14.5L23 227.2v-14.5zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm12.6 22.4v14.5l-12.6-7.3v-14.5l12.6 7.3zm.5.3l12.6 7.3v14.5l-12.6-7.3V243zm13.1 7.5l12.7 7.3v14.5L62.3 265v-14.5zm13.2 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.1 7.5l12.6 7.3V295l-12.6-7.3v-14.5zm13.1 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm13.2 7.6l12.6 7.3v14.5l-12.6-7.3v-14.5zm0-.6v-14.5l12.6 7.3v14.5l-12.6-7.3zm13.1-6.9l12.6 7.3v14.5l-12.6-7.3v-14.5zm12.6-98.9l-12.6-7.3v-14.6l12.6 7.3V182zM35.6 99.2v14.6L23 106.5V91.9l12.6 7.3zM23 227.8l12.6 7.3v14.5L23 242.3v-14.5zm118.1 82.7V296l12.6 7.3v14.5l-12.6-7.3z",
  fill: "#7a7a7a"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 127.678 175.753)",
  className: "hero_svg__st48",
  cx: 127.7,
  cy: 175.7,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 140.804 189.608)",
  className: "hero_svg__st48",
  cx: 140.8,
  cy: 189.6,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 114.556 180.47)",
  className: "hero_svg__st48",
  cx: 114.6,
  cy: 180.5,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 101.443 192.437)",
  className: "hero_svg__st48",
  cx: 101.5,
  cy: 192.4,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 88.325 204.306)",
  className: "hero_svg__st48",
  cx: 88.3,
  cy: 204.3,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 75.198 215.716)",
  className: "hero_svg__st48",
  cx: 75.2,
  cy: 215.7,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 62.082 194.48)",
  className: "hero_svg__st48",
  cx: 62.1,
  cy: 194.5,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 48.969 173.223)",
  className: "hero_svg__st48",
  cx: 49,
  cy: 173.2,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 35.849 132.595)",
  className: "hero_svg__st48",
  cx: 35.9,
  cy: 132.6,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 127.68 242.702)",
  className: "hero_svg__st48",
  cx: 127.7,
  cy: 242.7,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 140.796 250.279)",
  className: "hero_svg__st48",
  cx: 140.8,
  cy: 250.3,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 114.558 235.127)",
  className: "hero_svg__st48",
  cx: 114.6,
  cy: 235.1,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 101.441 227.551)",
  className: "hero_svg__st48",
  cx: 101.5,
  cy: 227.5,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 88.32 197.595)",
  className: "hero_svg__st48",
  cx: 88.3,
  cy: 197.6,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 75.2 167.135)",
  className: "hero_svg__st48",
  cx: 75.2,
  cy: 167.1,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 62.083 173.863)",
  className: "hero_svg__st48",
  cx: 62.1,
  cy: 173.9,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 48.967 212.341)",
  className: "hero_svg__st48",
  cx: 49,
  cy: 212.3,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-30 35.845 221.442)",
  className: "hero_svg__st48",
  cx: 35.9,
  cy: 221.4,
  rx: 1.2,
  ry: 2
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_46_",
  gradientUnits: "userSpaceOnUse",
  x1: 281.79,
  y1: 112.313,
  x2: 112.96,
  y2: 112.313,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M183.5 365.9c-6.1 3.5-13.7 3.5-19.8 0l-66.9-40.6v97.1c0 1.8 1 3.4 2.5 4.3l64.4 36.9c6.1 3.5 13.7 3.5 19.8 0l71.2-41.1c1.5-.9 2.5-2.5 2.5-4.3v-97.1l-73.7 44.8z",
  fill: "url(#hero_svg__SVGID_46_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_47_",
  gradientUnits: "userSpaceOnUse",
  x1: 189.809,
  y1: 131.012,
  x2: 152.819,
  y2: 280.812,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M167.6 368.2l-68.8-39.4c-1.9-1.1-2.6-3.5-1.5-5.5.4-.6.9-1.1 1.5-1.5l79.6-46c1.2-.7 2.8-.7 4 0l72.8 41.7c1.9 1.1 2.6 3.5 1.5 5.5-.4.6-.9 1.1-1.5 1.5l-75.6 43.7c-3.7 2.1-8.2 2.1-12 0z",
  fill: "url(#hero_svg__SVGID_47_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_48_",
  gradientUnits: "userSpaceOnUse",
  x1: 98.552,
  y1: 158.793,
  x2: 255.48,
  y2: 158.793,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M255.2 324.5l-75.6 43.7c-3.7 2.1-8.3 2.1-12 0l-68.8-39.4",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_48_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_49_",
  gradientUnits: "userSpaceOnUse",
  x1: 186.876,
  y1: 255.671,
  x2: 170.096,
  y2: 172.361,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_49_)",
  d: "M174.8 330.5l-52-29.8 56.4-32.6 52 29.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_50_",
  gradientUnits: "userSpaceOnUse",
  x1: 160.621,
  y1: 139.01,
  x2: 131.851,
  y2: 237.31,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_50_)",
  d: "M122.8 300.7v22.1l52 29.8v-22.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_51_",
  gradientUnits: "userSpaceOnUse",
  x1: 242.242,
  y1: 161.234,
  x2: 156.532,
  y2: 203.794,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_51_)",
  d: "M231.2 297.9l-56.4 32.6v22.1l56.4-32.5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_52_",
  gradientUnits: "userSpaceOnUse",
  x1: 122.552,
  y1: 191.708,
  x2: 231.47,
  y2: 191.708,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "url(#hero_svg__SVGID_52_)",
  strokeMiterlimit: 10,
  d: "M231.2 297.9l-56.4 32.6-52-29.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.5 418.5l62.2-35.9v-40.4l-62.2 35.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_53_",
  gradientUnits: "userSpaceOnUse",
  x1: 231.212,
  y1: 31.22,
  x2: 215.382,
  y2: 106.15,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_53_)",
  d: "M187.5 440.1l62.2-35.9v-14.4l-62.2 35.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.3 428.2v4.9l54.5-31.4v-4.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_54_",
  gradientUnits: "userSpaceOnUse",
  x1: 203.659,
  y1: 103.456,
  x2: 261.099,
  y2: 1.126,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#515151"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#595959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#6f6f6f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#8c8c8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#9f9f9f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#b0b0b0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#bbb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#bebebe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#aeaeae"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#909090"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#949494"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#a1a1a1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#b6b6b6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#bebebe"
})), /*#__PURE__*/React.createElement("path", {
  d: "M237.2 500.9l.4-2.9 5-.2.4-2.9 5-.2.4-2.9 5-.2.4-2.9 5-.2.4-2.9 5-.2.4-2.9 5-.2.4-2.9 5-.2.4-2.9 5.1-.2h.1L259 463.6c-3.1-1.8-5-5-5-8.6v-40c0-4.8-2.6-9.3-6.8-11.7l-4-2.3-48.2 27.8 4 2.3c4.2 2.4 6.8 6.9 6.8 11.7v40.1c0 3.6 1.9 6.8 5 8.6l21.3 12.1.3-2.6 4.8-.1z",
  fill: "url(#hero_svg__SVGID_54_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M94.6 389.2l1.2 8.9-2.7 2.1s3.6 6 2.1 8.9-5.5 4.1-5.5 4.1l.6-2.6-3 .6.8-2.2-3-.2 4.1-2.4s-9.1-8.1-4.3-13c2.6-2.7 6-4.2 9.7-4.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_55_",
  gradientUnits: "userSpaceOnUse",
  x1: 14868.94,
  y1: 104.87,
  x2: 14845.71,
  y2: 104.87,
  gradientTransform: "rotate(180 7474.68 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M94.6 389.2l1.2 8.9-2.7 2.1s3.6 6 2.1 8.9-5.5 4.1-5.5 4.1l.6-2.6-3 .6.8-2.2-3-.2 4.1-2.4s-9.1-8.1-4.3-13c2.6-2.7 6-4.2 9.7-4.2z",
  fill: "url(#hero_svg__SVGID_55_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M83.2 375.2c10.2-2.9 9.1 11.1 9.1 11.1s3.7-6.2 6.8-6.9 6.1 4.3 6.1 4.3l-2.9-.2 2.4 3.4-3.2-.3 1.3 3.5-4.6-2.3s-2 9.7-5.8 9.2-16.4-19.8-9.2-21.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_56_",
  gradientUnits: "userSpaceOnUse",
  x1: 14868.94,
  y1: 120.114,
  x2: 14845.71,
  y2: 120.114,
  gradientTransform: "rotate(180 7474.68 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M83.2 375.2c10.2-2.9 9.1 11.1 9.1 11.1s3.7-6.2 6.8-6.9 6.1 4.3 6.1 4.3l-2.9-.2 2.4 3.4-3.2-.3 1.3 3.5-4.6-2.3s-2 9.7-5.8 9.2-16.4-19.8-9.2-21.8z",
  fill: "url(#hero_svg__SVGID_56_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M65.5 363.1h.3c2.9.8 6 .9 9 .2.7-.2 1.5-.3 2.3-.2.6.1 1.1.3 1.6.6 1-2.9 3.5-5 7.4-6.3l.8-.3c3.9-1.3 7.1-1.2 9.7.4.2-.5.5-1 .9-1.5.6-.5 1.3-.9 2-1.2 2.8-1.2 5.2-3.2 7-5.6.1-.1.2-.2.3-.2h.4c.3.1.4.4.4.6 0 .2-.1 1.3-.1 1.6 0 1.3-.9 4.3-.2 7.3.1.3.1.6.2 1l-1.6.8 1.7.5c0 1.3-.3 2.6-.9 3.7l-2.3-.3 1.3 1.5c-.9.8-2 1.3-3.2 1.5.4.6.7 1.2.9 1.9.2 1 0 2.1-.5 2.9-1.2 1.6-2.8 2.9-4.6 3.7-.4.3-.7.7-.7 1.2 0 .7-1.1 1.4-3.3 2.2h-.1c-1 .4-2 .6-3 .6-.4 0-.7-.1-1-.4-.3-.4-.8-.6-1.3-.5-2.7.5-4.7.4-6.1-.2-1-.4-1.8-1.2-2.1-2.2-.2-.6-.3-1.2-.4-1.8-.4.2-.9.4-1.3.5l-.3-1.8-.7 1.9-.5-1-.5 1c-1.1-.1-2.2-.5-3.1-1.2l1.4-2.3-2.3 1.4c-.6-.6-1.1-1.3-1.5-2l.9-.9-1.3.2 1.3-1.3-1.7.6c-1.4-2.3-3.4-3.9-4.2-4.8-.2-.2-.9-1-1-1.2-.1-.1-.1-.2-.2-.2-.1.1 0-.2.2-.4z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_57_",
  gradientUnits: "userSpaceOnUse",
  x1: 14865.195,
  y1: 155.237,
  x2: 14856.925,
  y2: 133.917,
  gradientTransform: "rotate(180 7474.68 253)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M65.5 363.1h.3c2.9.8 6 .9 9 .2.7-.2 1.5-.3 2.3-.2.6.1 1.1.3 1.6.6 1-2.9 3.5-5 7.4-6.3l.8-.3c3.9-1.3 7.1-1.2 9.7.4.2-.5.5-1 .9-1.5.6-.5 1.3-.9 2-1.2 2.8-1.2 5.2-3.2 7-5.6.1-.1.2-.2.3-.2h.4c.3.1.4.4.4.6 0 .2-.1 1.3-.1 1.6 0 1.3-.9 4.3-.2 7.3.1.3.1.6.2 1l-1.6.8 1.7.5c0 1.3-.3 2.6-.9 3.7l-2.3-.3 1.3 1.5c-.9.8-2 1.3-3.2 1.5.4.6.7 1.2.9 1.9.2 1 0 2.1-.5 2.9-1.2 1.6-2.8 2.9-4.6 3.7-.4.3-.7.7-.7 1.2 0 .7-1.1 1.4-3.3 2.2h-.1c-1 .4-2 .6-3 .6-.4 0-.7-.1-1-.4-.3-.4-.8-.6-1.3-.5-2.7.5-4.7.4-6.1-.2-1-.4-1.8-1.2-2.1-2.2-.2-.6-.3-1.2-.4-1.8-.4.2-.9.4-1.3.5l-.3-1.8-.7 1.9-.5-1-.5 1c-1.1-.1-2.2-.5-3.1-1.2l1.4-2.3-2.3 1.4c-.6-.6-1.1-1.3-1.5-2l.9-.9-1.3.2 1.3-1.3-1.7.6c-1.4-2.3-3.4-3.9-4.2-4.8-.2-.2-.9-1-1-1.2-.1-.1-.1-.2-.2-.2-.1.1 0-.2.2-.4z",
  fill: "url(#hero_svg__SVGID_57_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M73.1 366.3c2.6.2 4.7.5 5.6 1.9s1.1 3.8 1.3 5.9c0 .2 0 .5.1.7-.4.2-.9.4-1.3.6l-.3-1.8-.7 1.9-.5-1-.5 1c-1.1-.1-2.2-.5-3.1-1.2l1.4-2.3-2.3 1.4c-.6-.6-1.1-1.3-1.5-2l.9-.9-1.3.2 1.3-1.3-1.7.6c-1.4-2.3-3.4-3.9-4.2-4.8-.2-.2-.9-1-1-1.2 2.6 2 5.2 2.1 7.8 2.3zm13.1-6.9c-.6.1-1.2.3-1.7.6-.3.2-.5.5-.2.6.5.1 1.1.1 1.6-.2.5-.4.6-.9.3-1zm.5 1.3c-.8.3-.1 1 .4.9s1.2-.6 1-.8-.9-.2-1.4-.1zm2-2.3c-.5.2-.9.7-1 1.3 0 .4.5.4 1.5.1s1.8-1 1.7-1.3-1.6-.2-2.2-.1zm10.8 2.7c.1-1 .1-2.3 2.3-4.1 1-.7 1.9-1.5 2.7-2.4 1.3-1.5 2.3-3.2 3-5 0 .2-.1 1.3-.1 1.6 0 1.3-.9 4.3-.2 7.3.1.3.1.6.2 1l-1.6.8 1.7.5c0 1.3-.3 2.6-.9 3.7l-2.3-.3 1.3 1.5c-.9.8-2 1.3-3.2 1.5l-.4-.6c-1.1-1.6-2.7-3.8-2.5-5.5zm-15.6 12c.4.9 1.2 1.2 2.8.6.2-.1.4-.1.6-.2 1.8-.7 2.4-1.3 4.4-2s2.8-.7 4.7-1.2c.2-.1.4-.1.7-.2 1.7-.6 2.1-1.3 1.9-2.2 1.8.6.6 2.9-.5 4-1.5 1.4-3.2 2.4-5.1 3l-.5.2c-1.9.7-3.9 1-5.9.8-1.8-.2-4.1-1.2-3.1-2.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st61",
  d: "M99 370.5c.3-.5.7-1.3.4-1.9m-.1 0c-.2.6-.5 1.1-1.1 1.3m0 .1l.7.5-.7-.5zm0 1.5c.2-.2.4-.4.5-.6v-.1l-.8-.5h-.1l.4 1.2c-.1 0 0 0 0 0zm-.4.2l-.2-1.3c0-.1-.1-.1-.1-.1l-.2.1c-.2.1-.4.2-.7.2h-.1c-.1 0-.1.1-.1.2l.1.1 1.3.8zm-1.8 1.5c.5-.3 1-.6 1.5-1 .1-.1.1-.2 0-.3l-1.6-1m-.1 0l-.1 2.1c0 .1.1.2.2.2h.1l-.2-2.3zm-.4 2.5l.1-2.3c0-.1-.1-.2-.2-.2l-.7.1-1.2.3c-.1 0-.1.1-.1.2v.1l2.1 1.8zm-2 1l1.5-.6c.1 0 .1-.1.1-.2v-.1l-1.7-1.6m-.2 0v2.3c0 .1.1.2.2.2h.1l-.3-2.5zm-.3 2.6v-2.7c0-.1-.1-.2-.2-.2l-.7.2-.7.3c-.1 0-.1.1-.1.2v.1l1.7 2.1zm-2.1.7c.5-.1 1-.3 1.6-.4.1 0 .1-.1.1-.2v-.1l-1.4-1.8m-.1 0l-.3 2.3c0 .1.1.2.1.2h.1l.1-2.5zm-.7 2.5l.4-2.7c0-.1 0-.1-.1-.1h-.1c-.4.2-.8.4-1.1.5l-.7.3c-.1 0-.1.1 0 .2l1.6 1.8zm-2.4.4c.6 0 1.2 0 1.8-.1.1 0 .2-.1.1-.2v-.1l-1.4-1.6m-.1 0c-.1.3-.4 1.3-.6 1.8 0 .1 0 .2.1.2h.1l.4-2zm-1.6.6l.6 1.1m.1.1l.5-1.5c0-.1 0-.1-.1-.2h-.1c-.2.1-.4.2-.7.2l-.2.1c-.1 0-.1.1-.1.2l.7 1.2zm-1.4 0c.3.1.5.1.8.2.1 0 .1 0 .1-.1l-.6-1.1m-.1 0l-.3.9v.1l.3-1zm-.9.7l.3.1m0 0l.2-.8m.1-.1c-.3.1-.7.1-1 0-.2-.1-.5-.2-.7-.3m-.1 0c0 .1 0 .1.1.2.3.4.6.7 1.1.9L84 374z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M97.6 362.1c-1.3.4-2.4 2.5-4.6 4.3-.8.7-1.7 1.3-1.8 1.4l1.5-.3c.9.7 2.1.9 3.2.5 1.4-.4 2.3-1.8 2-3.2 0-.3-.1-.7-.3-1-.8.3-1.6.7-2.3 1.2.6-.8 1.4-1.4 2.3-1.8.4-.2.9-.3 1.4-.3 0 0-.6-1-1.4-.8zm-16.2 6.8c1-.2 2-.2 2.9 0-.9.1-1.7.3-2.5.6.1.3.2.6.4.9.7 1.3 2.2 1.8 3.6 1.2 1.1-.3 1.9-1.3 2.2-2.4.5-.2 1-.4 1.4-.7-.2 0-1.2.1-2.3 0-2.9-.1-5-1-6.3-.5-.8.3-.6 1.5-.6 1.5.4-.3.8-.5 1.2-.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st62",
  d: "M84.4 368.9c-.9.1-1.7.3-2.5.6.1.3.2.6.4.9.7 1.3 2.2 1.8 3.6 1.2 1.1-.3 1.9-1.3 2.2-2.4-1.3 0-2.5-.1-3.7-.3zm8.3-1.4c.9.8 2.1 1 3.2.5 1.4-.4 2.3-1.8 2-3.2 0-.3-.1-.7-.3-1-.8.3-1.6.6-2.3 1.1-.8 1-1.6 1.9-2.6 2.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st63",
  d: "M93.9 367.5c-.3-.5 2.2-2.1 2.2-2.1.8-.6.9 0 .8.3s-.2 1.5-1 1.9-1.8.2-2-.1zm-10.4 3c.5.6 1.2.9 2 .9.9-.1 1.6-.8 1.5-1.4s-3-.2-3-.2c-.5 0-1.1.1-.5.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st61",
  d: "M94.7 366.5s-.8.5-.7.9 1.1-.9 1.4-1.2-.1-.2-.7.3zm-8.9 3.2s1-.1 1.1.3-1.4 0-1.8 0-.2-.3.7-.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M192.5 381.9l47.3-27.3m-3.1 8.5l6.1-3.5m-26 15l14.9-8.5m-39.2 22.5l19.9-11.4m14.1-1.4l16.3-9.4m-29 16.7l8-4.6m-29.3 16.9l11.2-6.4m-11.2 13.1l25.1-14.5M207 400.5l27.2-15.7m-41.7 25.1l9.4-5.5",
  fill: "none",
  stroke: "#e4e4e4",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_58_",
  gradientUnits: "userSpaceOnUse",
  x1: 204.4,
  y1: 208.709,
  x2: 163.23,
  y2: 208.709,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
})), /*#__PURE__*/React.createElement("path", {
  d: "M194.6 299.7v-15.2h-35v15.2c-.1 2.7 1.6 5.3 5.1 7.4 6.8 4 17.9 4 24.8 0 3.5-2 5.2-4.7 5.1-7.4z",
  fill: "url(#hero_svg__SVGID_58_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_59_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.431,
  y1: 231.732,
  x2: 179.631,
  y2: 205.482,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 177.1,
  cy: 284.5,
  rx: 17.5,
  ry: 10.1,
  fill: "url(#hero_svg__SVGID_59_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_60_",
  gradientUnits: "userSpaceOnUse",
  x1: 164.43,
  y1: 212.825,
  x2: 189.71,
  y2: 212.825,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M189.5 291.7c-6.8 4-17.9 4-24.8 0",
  fill: "none",
  stroke: "url(#hero_svg__SVGID_60_)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_61_",
  gradientUnits: "userSpaceOnUse",
  x1: 177.107,
  y1: 208.23,
  x2: 177.107,
  y2: 272.81,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0ea179"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#0ea179",
  stopOpacity: 0.56
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#0ea179",
  stopOpacity: 0.16
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#0ea179",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M163 231.2V282c-.5 3.1 2.1 6.3 7.6 8 4.1 1.3 8.5 1.3 12.6.1 5.3-1.6 8-4.5 8-7.4v-51.5H163z",
  opacity: 0.39,
  fill: "url(#hero_svg__SVGID_61_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st48",
  d: "M185 282.8v-5.3c0-4.3-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9v4.9c-.2 1.3.6 2.6 2.3 3.6 3.5 1.8 7.6 1.8 11.1 0 1.4-.5 2.3-1.8 2.4-3.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113.4 413.3l-2.5-1.5v-51.6l2.5 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st69",
  d: "M113.4 365.7l-2.5-1.4v-4.1l2.5 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.9 418.3l-2.5-1.5v-51.6l2.5 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st69",
  d: "M121.9 370.8l-2.5-1.5v-4.1l2.5 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.4 423.3l-2.5-1.5v-51.6l2.5 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st69",
  d: "M130.4 375.8l-2.5-1.5v-4.1l2.5 1.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.9 428.3l-2.5-1.4v-51.6l2.5 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b1dccb",
  d: "M138.9 380.8l-2.5-1.5v-4l2.5 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.4 433.3l-2.5-1.4v-51.6l2.5 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st69",
  d: "M147.4 385.8l-2.5-1.5v-4l2.5 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.9 438.3l-2.5-1.4v-51.6l2.5 1.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st69",
  d: "M155.9 390.8l-2.5-1.5v-4l2.5 1.4z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_62_",
  gradientUnits: "userSpaceOnUse",
  x1: 350.853,
  y1: 219.181,
  x2: 289.963,
  y2: 332.911,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3ab98e",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_62_)",
  d: "M429.5 149.9v189.7l-39.8 22.9-7.1-4.1v8.2l-39.8 22.9-7.1-4.1v8.1l-39.8 23-39.8-23V149.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M244.6 133.8c-6.2-2.2 1.4-12.2 1.5-16.9.1-4-3.6-12.9-4-16.3s4.8-7.5 6-4c.5 1.4-1.7.4-1.7.4s3.8-2.4 4.2 2c-.4.6-1.5-.3-1.5-.3s3.5-1.3 3.6 2.4c-1.2-.5-2.7 0-3.2 1.2-.1.2-.1.4-.2.6-.3 2 4.5 11 4.7 15.6.2 5.4-1.6 18.1-9.4 15.3z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_63_",
  gradientUnits: "userSpaceOnUse",
  x1: 253.347,
  y1: 415.976,
  x2: 245.517,
  y2: 384.536,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M244.6 133.8c-6.2-2.2 1.4-12.2 1.5-16.9.1-4-3.6-12.9-4-16.3s4.8-7.5 6-4c.5 1.4-1.7.4-1.7.4s3.8-2.4 4.2 2c-.4.6-1.5-.3-1.5-.3s3.5-1.3 3.6 2.4c-1.2-.5-2.7 0-3.2 1.2-.1.2-.1.4-.2.6-.3 2 4.5 11 4.7 15.6.2 5.4-1.6 18.1-9.4 15.3z",
  fill: "url(#hero_svg__SVGID_63_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M248.6 142.8l4.5 9.9 6.9-1.1s.2 8 3.3 9.9 4.9.2 7.8.6c.2-1.4-2.1-2.5-2.1-2.5 1-.3 2.1-.4 3.2-.2.2-1.6-2.1-2.4-2.1-2.4.7-.3 1.6-.4 2.4-.4 0-2.4-4.9-1.6-4.9-1.6s4-13.4-3.7-15.2c-6.8-1.5-15.3 3-15.3 3z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_64_",
  gradientUnits: "userSpaceOnUse",
  x1: 282.655,
  y1: 335.865,
  x2: 260.345,
  y2: 358.435,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M248.6 142.8l4.5 9.9 6.9-1.1s.2 8 3.3 9.9 4.9.2 7.8.6c.2-1.4-2.1-2.5-2.1-2.5 1-.3 2.1-.4 3.2-.2.2-1.6-2.1-2.4-2.1-2.4.7-.3 1.6-.4 2.4-.4 0-2.4-4.9-1.6-4.9-1.6s4-13.4-3.7-15.2c-6.8-1.5-15.3 3-15.3 3z",
  fill: "url(#hero_svg__SVGID_64_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M255.8 151.8c-1.5-6.7-7.9-10.5-7.9-10.5l-8.9 5.3 4.6 6.9s-7.1 3.7-7.5 7.3 2.1 4.9 2.8 7.3c2-.6 1-2.9 1-2.9 1 .7 1.9 1.7 2.5 2.8 1.4-1 .7-3 .7-3 1.1.4 2 1 2.8 1.9 1.4-2.3-2.1-5.1-2.1-5.1s13.7-2.3 12-10z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M252.9 131.1c-3.1-6.8-15.8-4.6-15-1.2 1.9 8.1-1.4 10.4-.1 16.4 1.2 5.6 4.7 6.9 6.4 8.2 4.1 3.1 10.6-3.3 12.4-8.6 1.7-4.9-2-11.1-3.7-14.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_65_",
  gradientUnits: "userSpaceOnUse",
  x1: 260.209,
  y1: 383.731,
  x2: 241.159,
  y2: 360.371,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M252.9 131.1c-3.1-6.8-15.8-4.6-15-1.2 1.9 8.1-1.4 10.4-.1 16.4 1.2 5.6 4.7 6.9 6.4 8.2 4.1 3.1 10.6-3.3 12.4-8.6 1.7-4.9-2-11.1-3.7-14.8z",
  fill: "url(#hero_svg__SVGID_65_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M249.3 118c-2.8-4.2 3.7-3.2 2.8-9.6 1.9 1.4 3.2 3.4 3.7 5.7.5 2.9 2.1 4.5 1.5 7-.5 2.2-3.2 2.4-4.4 1.6-2.1-1.3-2.5-3.1-3.6-4.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M250.1 112.6c-3.6-2.5-12.2-1.5-16.1 6.4-1.3 2.6 3.7.8 1.8 6.3-2.8 8 15.2 9.6 19.2 7.5.5-.3 2.8-3.9 2-5.7.1-.5.1-1.1.1-1.6 1.3-.9-.1-2.7-.5-3.2.6-1.3.6-2.9-.1-4.1-.9-1.4-4.9-4.5-6.4-5.6z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_66_",
  gradientUnits: "userSpaceOnUse",
  x1: 248.157,
  y1: 399.77,
  x2: 244.497,
  y2: 376.02,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M250.1 112.6c-3.6-2.5-12.2-1.5-16.1 6.4-1.3 2.6 3.7.8 1.8 6.3-2.8 8 15.2 9.6 19.2 7.5.5-.3 2.8-3.9 2-5.7.1-.5.1-1.1.1-1.6 1.3-.9-.1-2.7-.5-3.2.6-1.3.6-2.9-.1-4.1-.9-1.4-4.9-4.5-6.4-5.6z",
  fill: "url(#hero_svg__SVGID_66_)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "hero_svg__SVGID_67_",
  d: "M250.1 112.6c-3.6-2.5-12.2-1.5-16.1 6.4-1.3 2.6 3.7.8 1.8 6.3-2.8 8 15.2 9.6 19.2 7.5.9-.5 3.6-8.5 1.6-10.6.6-1.3.6-2.9-.1-4.1-.9-1.3-4.9-4.4-6.4-5.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "hero_svg__SVGID_68_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hero_svg__SVGID_67_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hero_svg__SVGID_68_)"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st61",
  d: "M258.8 125.8c.4-.4 1-1.1.8-1.6m-.1 0c-.3.5-.8.9-1.4 1l.6.5.8-1.5zm-1.8 2.4c.2-.1.5-.3.7-.5v-.1l-.7-.6h-.1l.1 1.2c-.1 0 0 0 0 0zm-.4.1v-1.1c0-.1-.1-.1-.1-.1h-.2l-.8.1h-.1c-.1 0-.1.1-.1.1v.1l1.2.9h.1zm-2.3 1.1c.6-.2 1.2-.4 1.8-.7.1 0 .1-.1.1-.2-.4-.3-1.2-.9-1.4-1.1h-.1l-.5 1.8c-.1.2-.1.2.1.2zm-.6.1l.6-2c0-.1 0-.2-.1-.2h-.1l-.7.1-1.3.1c-.1 0-.1.1-.1.1v.1l1.7 1.8zm-2.3.7c.6-.1 1.2-.3 1.7-.4.1 0 .2-.1.1-.2v-.1l-1.5-1.6m0 .1l-.5 2c0 .1.1.2.1.2l.4-2.2zm-1 2.2l.6-2.3c0-.1-.1-.2-.1-.2l-.8.1-.8.2c-.1 0-.2.1-.1.2l1.2 2zm-2.3.4c.6-.1 1.1-.1 1.8-.2.1 0 .2-.1.2-.2v-.1l-1.1-1.7m-.2 0l-.9 2c0 .1 0 .2.1.2l.8-2.2zm-1.3 2.1l1-2.2c0-.1 0-.1-.1-.1h-.1l-1.3.3-.8.2c-.1 0-.1.1-.1.1l1.4 1.7zm-2.6.1c.6.1 1.3.1 1.9.1.1 0 .2-.1.2-.2v-.1l-1.1-1.5h-.1c-.1 0 0 0 0 0-.2.2-.7 1.1-1 1.5-.1 0-.1.1.1.2-.1 0-.1 0 0 0zm-1-1.2l.4 1h.1l.8-1.3v-.1h-.1c-.3.1-.5.1-.8.2h-.3c-.1 0-.1.1-.1.1v.1zm-.9.8c.3.1.5.2.8.2.1 0 .1 0 .1-.1l-.4-1m0 .1l-.5.8v.1l.5-.9zm-1.3.5l.3.1h.1l.4-.7c-.4 0-.7 0-1.1-.1-.2-.1-.5-.2-.6-.4h-.1v.2c.3.5.6.8 1 .9z",
  id: "hero_svg__Teeth"
})), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M223.8 113.7c.1-.1.2-.2.4-.2.1 0 .2 0 .3.1 2.6 1.3 5.5 2 8.5 1.9.7 0 1.5 0 2.2.2.5.2 1 .5 1.4.9 1.5 1.8 2 8.4-.9 10.9-1.1.3-2.3.3-3.4.1l.5-1.9-1.8 1.3c-1-.7-1.8-1.7-2.4-2.8l1.2-1.2h-1.7l-.3-.9c-.7-2.9-2.7-5.1-3.3-6.2-.1-.2-.6-1.2-.8-1.4-.1-.3 0-.6.1-.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_69_",
  gradientUnits: "userSpaceOnUse",
  x1: 232.96,
  y1: 402.101,
  x2: 229.3,
  y2: 378.361,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M223.8 113.7c.1-.1.2-.2.4-.2.1 0 .2 0 .3.1 2.6 1.3 5.5 2 8.5 1.9.7 0 1.5 0 2.2.2.5.2 1 .5 1.4.9 1.5 1.8 2 8.4-.9 10.9-1.1.3-2.3.3-3.4.1l.5-1.9-1.8 1.3c-1-.7-1.8-1.7-2.4-2.8l1.2-1.2h-1.7l-.3-.9c-.7-2.9-2.7-5.1-3.3-6.2-.1-.2-.6-1.2-.8-1.4-.1-.3 0-.6.1-.8z",
  fill: "url(#hero_svg__SVGID_69_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M235.7 120.9c-.5-.8-1-1.9-3.8-2.6h-.1c-1.1-.2-2.2-.5-3.3-.9-1.7-.7-3.4-1.7-4.8-3 .1.2.6 1.1.8 1.4.6 1.1 2.6 3.3 3.3 6.2l.3.9h1.7l-1.2 1.2c.5 1.1 1.3 2.1 2.4 2.8l1.8-1.2-.5 1.9c1.1.3 2.3.3 3.4-.1 0-.2 0-.4.1-.7.3-1.9.8-4.5-.1-5.9zm11.8-7.6c.3-.2 1.6-.1 1.6-.1.3 0 .5.3.4.5-.4.3-.9.4-1.3.3-.8-.1-1-.5-.7-.7zm-.1 1.3c.7 0 .4.8-.1 1s-1.1-.1-1-.4.8-.5 1.1-.6zm-2.3-1.4c.5 0 1 .3 1.2.8.1.3-.3.5-1.2.7s-1.7-.3-1.7-.6 1.2-.8 1.7-.9z"
}), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow_Eyes"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M249.3 122.7c.4-.1.7-.2 1.1-.4 0 0-.8-.2-1.8-.5-2.9-.8-4.9-2.2-6.4-2-.9.1-1 1.4-1 1.4.4-.2.9-.4 1.4-.4 1 0 2.1.2 3 .7"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st62",
  d: "M245.6 121.5c-.9-.1-1.8-.1-2.7 0 0 .3.1.7.2 1 .4 1.5 1.9 2.4 3.4 2.1 1.2-.1 2.3-.9 2.8-2"
}))), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st63",
  d: "M246.7 122.3c-.7-.2-1.3-.2-2-.2 0 .2 0 .4.1.6.2.9 1.1 1.4 2 1.2.7-.1 1.3-.5 1.6-1.2-.5-.2-1.1-.4-1.7-.4z",
  id: "hero_svg__Brow_Eyes-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Brow_Eyes-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M254.7 120.9c.4-.4.9-.7 1.4-.9.3 0 .5 0 .8.1 0 0-.2-.9-.7-.9-.8 0-1.6 1.3-3 2.3-.4.2-.7.5-1.1.7.3 0 .6.1.9.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st62",
  d: "M253 122.2c.3.7.9 1.1 1.6 1.1 1-.1 1.4-1 1.5-2v-.8c-.5 0-.9.1-1.4.3"
}))), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_w_mascot-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st63",
  d: "M254.3 121.6c.3-.2.6-.3 1-.4v.4c.1.5-.3 1-.8 1-.4 0-.8-.2-.9-.5.2-.1.5-.3.7-.5z",
  id: "hero_svg__Brow_Eyes-4"
})), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st61",
  d: "M247.3 122.4s.9 0 1 .4-1.4-.2-1.8-.2 0-.2.8-.2zm7-.7s-.6.2-.6.5.8-.4 1-.5.1-.2-.4 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st27",
  d: "M266 107.4c-.5-1.9-1.6-2.2-2.6-1.9-1.5-3-6.2 1.2-5.8 4.5s2.4 13.4.2 15.3c-3.1 2.8-15.2 6.8-12.9 13.1 2.5 6.8 17.3-4 19.9-9.3 2-4-.1-15 .2-17.1.2-1.3 1.4-2.3 2.7-2.1.2 0 .4.1.6.1-.2-2.1-1.3-2.5-2.3-2.6z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_70_",
  gradientUnits: "userSpaceOnUse",
  x1: 264.539,
  y1: 407.803,
  x2: 250.709,
  y2: 359.003,
  gradientTransform: "matrix(1 0 0 -1 0 506)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3fb984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#3fb984",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#3fb984",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3fb984",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M266 107.4c-.5-1.9-1.6-2.2-2.6-1.9-1.5-3-6.2 1.2-5.8 4.5s2.4 13.4.2 15.3c-3.1 2.8-15.2 6.8-12.9 13.1 2.5 6.8 17.3-4 19.9-9.3 2-4-.1-15 .2-17.1.2-1.3 1.4-2.3 2.7-2.1.2 0 .4.1.6.1-.2-2.1-1.3-2.5-2.3-2.6z",
  fill: "url(#hero_svg__SVGID_70_)"
})));

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hero_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 519.1 503.8",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/hero.0cfe5363.svg";
export { SvgHero as ReactComponent };